<template>
    <div>
        <MenuPos />
        <!-- <div class="d-flex justify-space-between mb-2">
            <div class="d-flex justify-center align-center">
                <div class="img_title_takeout_admin">
                    <img src="@/assets/food-package.png">
                </div>
                <h2 class="title_takeout_admin">ซื้อกลับบ้าน</h2>
            </div>
            <v-btn color="success" height="50" width="20%" @click="$router.push('/poslist')">
                ย้อนกลับ
            </v-btn>
        </div> -->
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <v-card>
                <div class="pa-3">
                    <v-row>
                        <v-col cols="12">
                            <div class="text-right mb-3">
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="link_nametakeoutuser_takeout_admin" height="50" width="auto"
                                            v-bind="attrs" v-on="on">
                                            สร้าง QR-CODE พรีออเดอร์
                                        </v-btn>
                                    </template>
                                    <v-stepper v-model="step" style="width:300px">
                                        <v-stepper-items>
                                            <v-stepper-content step="1">
                                                <v-btn class="mb-2 titlefont_poslist white--text grad-primary-bg"
                                                    height="50" width="100%" @click="nextStep(1)">
                                                    บุฟเฟ่ต์
                                                </v-btn>
                                                <v-btn class="mb-2 titlefont_poslist white--text grad-primary-bg"
                                                    height="50" width="100%" @click="nextStep(0)">
                                                    ทานที่ร้าน
                                                </v-btn>
                                            </v-stepper-content>
                                            <v-stepper-content step="2">
                                                <div v-if="type == 1">
                                                    <div v-if="loading_ragne === true">
                                                        <v-sheet
                                                            :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
                                                            class="pa-3">
                                                            <v-skeleton-loader
                                                                type="article, actions"></v-skeleton-loader>
                                                        </v-sheet>
                                                    </div>
                                                    <div v-if="loading_ragne === false">
                                                        <div
                                                            class="mb-2 d-flex justify-space-between titlefont_poslist">
                                                            <div>
                                                                <v-icon large
                                                                    @click="step = 1">mdi-arrow-left-bold-circle</v-icon>
                                                            </div>
                                                            <v-card class="pl-2 pr-2 white--text grad-primary-bg">
                                                                บุฟเฟ่ต์
                                                            </v-card>
                                                        </div>
                                                        <div class="mb-2" v-for="(ragne_detail, index) in ragne_list"
                                                            :key="index">
                                                            <v-card
                                                                class="py-2 titlefont_poslist white--text text-center grad-primary-bg cursor_delivery_poslist buffet_list_step_three_poslist"
                                                                width="100%" @click="nextStepBuffet(ragne_detail.id)">
                                                                {{ ragne_detail.name_ragne }}
                                                            </v-card>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div v-if="type == 0">
                                                    <div class="mb-2 d-flex justify-space-between titlefont_poslist">
                                                        <div>
                                                            <v-icon large
                                                                @click="step = 1">mdi-arrow-left-bold-circle</v-icon>
                                                        </div>
                                                        <v-card class="pl-2 pr-2 white--text grad-primary-bg">
                                                            ทานที่ร้าน
                                                        </v-card>
                                                    </div>
                                                    <form @submit.prevent="openTableNotBuffet()">
                                                        <div class="mb-2">
                                                            <div class="d-flex justify-center">
                                                                <div
                                                                    class="d-flex align-center h_full_poslist w_half_poslist titlefont_poslist">
                                                                    ลูกค้า
                                                                </div>
                                                                <div
                                                                    class="d-flex justify-center align-center w_half_poslist">
                                                                    <div @click="addNumCustomerNot_buffet('minus')"
                                                                        class="cursor_number_table_icon_poslist">
                                                                        <v-icon size="40">mdi-minus-circle</v-icon>
                                                                    </div>
                                                                    <div class="ml-2 mr-2 titlefont_poslist">
                                                                        {{ add_num_customer_not_buffet }}
                                                                    </div>

                                                                    <div @click="addNumCustomerNot_buffet('plus')"
                                                                        class="cursor_number_table_icon_poslist">
                                                                        <v-icon size="40">mdi-plus-circle</v-icon>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <v-btn dark class="titlefont_poslist" height="50" type="submit"
                                                            width="100%">
                                                            สร้าง QR-CODE
                                                        </v-btn>
                                                    </form>
                                                </div>
                                            </v-stepper-content>
                                            <v-stepper-content step="3">
                                                <div v-if="loading_buffet_manage === true">
                                                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
                                                        class="pa-3">
                                                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                                                    </v-sheet>
                                                </div>
                                                <div v-if="loading_buffet_manage === false">
                                                    <div class="mb-2 d-flex justify-space-between titlefont_poslist">
                                                        <div>
                                                            <v-icon large
                                                                @click="step = 2">mdi-arrow-left-bold-circle</v-icon>
                                                        </div>
                                                        <v-card class="pl-2 pr-2 white--text grad-primary-bg">
                                                            {{ ragne_name }}
                                                        </v-card>
                                                    </div>
                                                    <form @submit.prevent="openTableBuffet(ragne_id)">
                                                        <div class="mb-2">
                                                            <div class="d-flex justify-center"
                                                                v-for="(buffet_choi, key_buffet) in data_buffet_choi"
                                                                :key="key_buffet">
                                                                <div
                                                                    class="d-flex align-center h_full_poslist w_half_poslist titlefont_poslist">
                                                                    {{
            buffet_choi.name }}
                                                                </div>
                                                                <div
                                                                    class="d-flex justify-center align-center w_half_poslist">
                                                                    <div @click="addNumCustomer_buffet('minus', buffet_choi.id)"
                                                                        class="cursor_number_table_icon_poslist">
                                                                        <v-icon size="40">mdi-minus-circle</v-icon>
                                                                    </div>
                                                                    <div class="ml-2 mr-2 titlefont_poslist">
                                                                        {{ buffet_choi.count }}
                                                                    </div>

                                                                    <div @click="addNumCustomer_buffet('plus', buffet_choi.id)"
                                                                        class="cursor_number_table_icon_poslist">
                                                                        <v-icon size="40">mdi-plus-circle</v-icon>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <v-btn dark class="titlefont_poslist" height="50" type="submit"
                                                            width="100%">
                                                            สร้าง QR-CODE
                                                        </v-btn>
                                                    </form>
                                                </div>
                                            </v-stepper-content>
                                        </v-stepper-items>
                                    </v-stepper>
                                </v-menu>
                            </div>

                            <div>
                                <div v-for="(detail, key) in data" :key="key">
                                    <div class="pa-3 mt-3 detail_food_yellow_takeout_admin"
                                        @click="pageDetail(detail.opentable_id)" v-if="detail.status_pre_order == 0">
                                        <div class="d-flex justify-space-between  align-center">
                                            <div>
                                                <div>คิว {{ detail.name_pre_order }} | เวลา
                                                    {{ detail.waiting_time_format }} น. รออยู่ {{
            timeSince(detail.waiting_time) }}</div>
                                            </div>
                                            <div class="text-right">
                                                <div class="font_food_yellow_takeout_admin">
                                                    กำลังรอโต๊ะ
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pa-3 mt-3 detail_food_green_takeout_admin"
                                        @click="pageDetail(detail.opentable_id)" v-if="detail.status_pre_order == 1">
                                        <div class="d-flex justify-space-between  align-center">
                                            <div>
                                                <div>
                                                    <div>คิว {{ detail.name_pre_order }} | เวลา
                                                        {{ detail.waiting_time_format }} น.</div>
                                                </div>
                                            </div>
                                            <div class="text-right">
                                                <div class="font_food_green_takeout_admin">
                                                    เสร็จสิ้น
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pa-3 mt-3 detail_food_red_takeout_admin"
                                        @click="pageDetail(detail.opentable_id)" v-if="detail.status_pre_order == 2">
                                        <div class="d-flex justify-space-between  align-center">
                                            <div>
                                                <div>
                                                    <div>คิว {{ detail.name_pre_order }} | เวลา
                                                        {{ detail.waiting_time_format }} น.</div>
                                                </div>
                                            </div>
                                            <div class="text-right">
                                                <div class="font_food_red_takeout_admin">
                                                    ยกเลิกจองคิว
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
            <!-- QR Code -->
            <v-dialog v-model="open_qr_code" persistent max-width="600px">
                <div v-if="loading_page_qr_code === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                </div>
                <v-card v-if="loading_page_qr_code === false">

                    <v-card-title class="justify-end">
                        <div class="cursor_icon_pos_table_detail" @click="open_qr_code = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>

                        <v-row>
                            <v-col cols="12">
                                <h1 class="text-center mb-3">สแกน QR Code</h1>
                                <div class="qr_code_pos_table_detail mb-3">
                                    <img :src="qr_code">
                                </div>
                                <hr class="mb-3" style="border-style:dashed;" v-if="start_time && end_time">
                                <div class="d-flex justify-space-between black--text" v-if="start_time && end_time">
                                    <h3>เวลาเริ่มบุฟเฟต์ : {{ start_time}} น.</h3>
                                    <h3>เวลาหมดบุฟเฟต์ : {{ end_time}} น.</h3>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import MenuPos from '@/components/menuadmin/MenuPos.vue'
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'preorderlist',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    components: {
        MenuPos
    },
    data() {
        return {
            loading_page: true,
            loading_ragne: true,
            loading_buffet_manage: true,
            data: [],
            step: 1,
            type: null,
            add_num_customer_not_buffet: 0,
            per_table: [],
            per_table_list: [],
            per_table_no_select_table_list: [],
            check_per_table: 0,
            ragne_list: [],
            ragne_id: null,
            ragne_name: null,
            data_buffet_choi: [],
            alert_error_amount_buffet: false,
            alert_error_amount_no_buffet: false,
            alert_add_num_table: false,
            open_add_num_table: false,
            alert_takeOut: false,
            table_takeOut_id: null,
            table_takeOut_name: null,
            lastPreOrder: null,
            loading_page_qr_code: true,
            open_qr_code: false,
            qr_code: null,
            start_time: null,
            end_time: null,
            intervalId: null
        }
    },
    methods: {
        async nextStep(type) {
            if (type === 1) {
                await this.ragneList()
            }
            this.add_num_customer_not_buffet = 0
            this.step = 2
            this.type = type
            this.check_per_table = 0
            this.per_table = []

        },
        async nextStepBuffet(id) {
            await this.getBuffetManage(id)
            this.step = 3
        },
        async addNumCustomer_buffet(type, id) {
            const result_buffet = this.data_buffet_choi.find((detail) => {
                return detail.id == id
            })

            if (type === 'plus') {
                result_buffet.count += 1
            }
            if (type === 'minus' && result_buffet.count > 0) {
                result_buffet.count -= 1
            }
        },
        async addNumCustomerNot_buffet(type) {
            if (type === 'plus') {
                this.add_num_customer_not_buffet += 1
            }
            if (type === 'minus' && this.add_num_customer_not_buffet > 0) {
                this.add_num_customer_not_buffet -= 1
            }
        },
        async ragneList() {
            this.loading_ragne = true
            this.ragne_list = []
            HTTP.get('/POS/table/list_ragne', {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
                .then((response) => {
                    if (response.data.successful === true) {
                        response.data.ragneList.forEach((detail, index) => {
                            if (index > 1) {
                                this.ragne_list.push({
                                    id: detail.id,
                                    name_ragne: detail.name_ragne,
                                })
                            }
                        })
                        this.loading_ragne = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async getBuffetManage(id) {
            this.loading_buffet_manage = true
            this.ragne_id = id
            const ragne_detail = this.ragne_list.find((detail) => { return detail.id == id })
            this.ragne_name = ragne_detail.name_ragne
            HTTP.get('/POS/table/buffet-choi/' + id, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
                .then((response) => {
                    if (response.data.successful === true) {
                        for (let index = 0; index < response.data.buffet.length; index++) {
                            response.data.buffet[index].count = 0

                        }
                        this.data_buffet_choi = response.data.buffet
                        this.loading_buffet_manage = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async openTableBuffet() {
            let status_table = 0
            if (this.check_per_table === true || this.check_per_table == 1) {
                status_table = 1
            }
            const result_id = this.data_buffet_choi.map((detail) => detail.id);
            const result_amount = this.data_buffet_choi.map((detail) => detail.count);
            const checkResult_amount = result_amount.reduce((sum, number) => sum + number, 0)

            if (checkResult_amount <= 0) {
                this.alert_error_amount_buffet = true
                setTimeout(() => this.alert_error_amount_buffet = false, 5000)
            } else {
                if (status_table == 1 && this.per_table.length <= 0) {
                    this.alert_error_per_table = true
                    setTimeout(() => this.alert_error_per_table = false, 5000)
                } else {
                    this.loading_page = true
                    await HTTP.post('/POS/table/open-table-pre-order', {
                        status_table: status_table,
                        tables: this.per_table,
                        type: "บุฟเฟ่",
                        ragne_id: this.ragne_id,
                        id: result_id,
                        amount: result_amount
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                        .then(async (response) => {
                            if (response.data.successful === true) {
                                this.step = 1
                                this.data_buffet_choi = []
                                this.table_takeOut_id = null
                                this.table_takeOut_name = null
                                this.add_num_customer_not_buffet = 0
                                this.lastPreOrder = response.data.list
                                await this.printOrderPreOrder(response.data.list)
                                this.loading_page = false
                            }
                            if (response.data.successful === false) {
                                this.message_error_open_table = response.data.msg
                                this.alert_error_open_table = true
                                setTimeout(() => this.alert_error_open_table = false, 5000)
                                this.loading_page = false
                            }

                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                }
            }
        },
        async openTableNotBuffet(id) {
            let status_table = 0
            if (this.check_per_table === true) {
                status_table = 1
            }
            if (this.add_num_customer_not_buffet <= 0) {
                this.alert_error_amount_no_buffet = true
                setTimeout(() => this.alert_error_amount_no_buffet = false, 5000)
            } else {
                if (status_table == 1 && this.per_table.length <= 0) {
                    this.alert_error_per_table = true
                    setTimeout(() => this.alert_error_per_table = false, 5000)
                } else {
                    this.loading_page = true
                    HTTP.post('/POS/table/open-table-not-buffet-pre-order', {
                        table_id: id,
                        status_table: status_table,
                        tables: this.per_table,
                        type: "ไม่บุฟเฟ่",
                        amount: this.add_num_customer_not_buffet
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                        .then(async (response) => {
                            if (response.data.successful === true) {
                                this.data_buffet_choi = []
                                this.table_takeOut_id = null
                                this.table_takeOut_name = null
                                this.add_num_customer_not_buffet = 0
                                await this.printOrderPreOrder(response.data.list)
                                this.loading_page = false
                            }
                            if (response.data.successful === false) {
                                this.message_error_open_table = response.data.msg
                                this.alert_error_open_table = true
                                setTimeout(() => this.alert_error_open_table = false, 5000)
                                this.loading_page = false
                            }

                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                }
            }
        },
        async printOrderPreOrder(data) {
            console.log(data);
            this.loading_page = true
            HTTP.get(`/POS/table/qr-pre_order/${data.id}/${data.token}/${data.name_pre_order}`, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            }).then(async (response) => {
                if (response.data.successful === true) {

                    this.loading_page_qr_code = false
                    this.open_qr_code = true
                    await this.preOrderList()
                    this.qr_code = response.data.QR_code
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async preOrderList() {
            this.loading_page = true
            HTTP.get('/POS/table/list_pre_order', {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
                .then(async (response) => {
                    if (response.data.successful === true) {
                        this.data = response.data.pre_order
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async pageDetail(id) {
            this.$router.push('/preorderdetail/' + id);
        },

        timeSince(waitingTime) {
            const now = new Date();
            const waitingDate = new Date();

            const [hours, minutes, seconds] = waitingTime.split(':');
            waitingDate.setHours(hours, minutes, seconds, 0);

            let diff = now - waitingDate; // difference in milliseconds

            // Calculate hours, minutes, and seconds
            const diffHours = Math.floor(diff / (1000 * 60 * 60));
            diff -= diffHours * (1000 * 60 * 60);
            const diffMinutes = Math.floor(diff / (1000 * 60));
            diff -= diffMinutes * (1000 * 60);
            const diffSeconds = Math.floor(diff / 1000);

            // Formatting the output
            return `${this.padTime(diffHours)}:${this.padTime(diffMinutes)}:${this.padTime(diffSeconds)} น.`;
        },
        padTime(t) {
            return t.toString().padStart(2, '0');
        }
    },
    mounted() {
        this.preOrderList()
        this.intervalId = setInterval(() => {
            this.$forceUpdate();
        }, 1000); // Update every second
    },
    created() {
        this.preOrderList();
    },
}
</script>
<style scoped>
.add_delivery_poslist {
    border-bottom: 1px solid;

}

.cursor_delivery_poslist {
    cursor: pointer;
}

.buffet_list_step_three_poslist:hover::before {
    opacity: .08;
}

.colorpicker_poslist {
    width: 25px;
}

.open_table_pos_list {
    padding: 15px;
    background: #ffe1a0;
    border-radius: 20px;
}

.open_per_table_pos_list {
    padding: 15px;
    background: #806554;
    border-radius: 20px;
}

.open_on_table_pos_list {
    padding: 15px;
    background: #6c6c6c;
    border-radius: 20px;
}

.detail_table_list_pos_list {
    display: grid;
    grid-template-columns: 50% 50%;
}

.clock_notification_image {
    width: 30%;
    margin: auto;
}

.clock_notification_image>img {
    max-width: 100%;
}
</style>